/**
 * Data layer for `google-ads-gclid-parallel-tracking-native-integrat`. Thin typed fetch wrappers over /api/v1/google-ads-gclid-parallel-tracking-native-integrat.
 * Raw `fetch()` is confined to this file per the dash contract.
 */

export interface GoogleAdsGclidParallelTrackingNativeIntegratRow {
	id: string;
	tenant_id: string;
	created_at: number;
	updated_at: number;
	[key: string]: unknown;
}

export interface ListGoogleAdsGclidParallelTrackingNativeIntegratResponse {
	count: number;
	items: GoogleAdsGclidParallelTrackingNativeIntegratRow[];
}

export interface CreateGoogleAdsGclidParallelTrackingNativeIntegratBody {
	[key: string]: unknown;
}

const BASE = "/api/v1/google-ads-gclid-parallel-tracking-native-integrat";

async function parseOrThrow<T>(res: Response): Promise<T> {
	const text = await res.text();
	let data: unknown = null;
	if (text) {
		try {
			data = JSON.parse(text);
		} catch {
			data = text;
		}
	}
	if (!res.ok) {
		const msg =
			data &&
			typeof data === "object" &&
			data !== null &&
			"error" in data &&
			typeof (data as { error: unknown }).error === "string"
				? (data as { error: string }).error
				: `HTTP ${res.status}`;
		throw new Error(msg);
	}
	return data as T;
}

export async function list(): Promise<ListGoogleAdsGclidParallelTrackingNativeIntegratResponse> {
	const res = await fetch(BASE, {
		method: "GET",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<ListGoogleAdsGclidParallelTrackingNativeIntegratResponse>(res);
}

export async function create(body: CreateGoogleAdsGclidParallelTrackingNativeIntegratBody): Promise<GoogleAdsGclidParallelTrackingNativeIntegratRow> {
	const res = await fetch(BASE, {
		method: "POST",
		credentials: "include",
		headers: {
			accept: "application/json",
			"content-type": "application/json",
		},
		body: JSON.stringify(body ?? {}),
	});
	return parseOrThrow<GoogleAdsGclidParallelTrackingNativeIntegratRow>(res);
}

export async function remove(id: string): Promise<{ removed: boolean }> {
	const res = await fetch(`${BASE}/${encodeURIComponent(id)}`, {
		method: "DELETE",
		credentials: "include",
		headers: { accept: "application/json" },
	});
	return parseOrThrow<{ removed: boolean }>(res);
}

export const googleAdsGclidParallelTrackingNativeIntegratQueryKeys = {
	all: ["google-ads-gclid-parallel-tracking-native-integrat"] as const,
	list: () => [...googleAdsGclidParallelTrackingNativeIntegratQueryKeys.all] as const,
	detail: (id: string) => [...googleAdsGclidParallelTrackingNativeIntegratQueryKeys.all, id] as const,
};
